import { Box, Divider, Typography, makeStyles } from '@material-ui/core'
import React from 'react'

import BudgetsTab from './BudgetsTab'
import OverviewTab from './OverviewTab'

// Budgets now also carries what used to be the Overview tab (2026-07-30): the
// per-apartment budget vs spend rollup + kit completeness on top, the editable
// pots grid below. The first tab is the action Dashboard instead.
const useStyles = makeStyles((theme) => ({
  heading: { fontWeight: 700, margin: theme.spacing(1, 0) },
  divider: { margin: theme.spacing(3, 0, 2) }
}))

const BudgetsOverviewTab = () => {
  const classes = useStyles()
  return (
    <Box>
      <OverviewTab />
      <Divider className={classes.divider} />
      <Typography className={classes.heading}>Set budgets</Typography>
      <BudgetsTab />
    </Box>
  )
}

export default BudgetsOverviewTab
